import { RenderingSection } from '@zinnia/form-engine-sdk';
import { DynamicPdfType } from '@breathelife/types';

import { pdfTypeLookup } from '../types';

export function filterSectionsByPdfType(sections: RenderingSection[], pdfType: DynamicPdfType): RenderingSection[] {
  return sections.filter((section: RenderingSection) => section.documentTypes.includes(pdfTypeLookup[pdfType]));
}
